import type { IExtendedTelemetryItem } from '@microsoft/1ds-analytics-js';
import { isScorecardNrtEvent } from 'owa-analytics-events';

type OneDsEventBaseType = 'scorecard_nrt' | 'scorecard' | 'default';

export function setOneDsEventBaseType(item: IExtendedTelemetryItem): void {
    if (item.baseType !== undefined) {
        return;
    }

    const eventName = item.data?.EventName;
    let baseType: OneDsEventBaseType = 'default';

    if (typeof eventName === 'string' && isScorecardNrtEvent(eventName)) {
        baseType = 'scorecard_nrt';
    } else if (item.data?.IsScorecardEvent === true) {
        baseType = 'scorecard';
    }

    item.baseType = baseType;
}
